pageId = 'page-tower-pro'
page = '#' + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  Intercom('trackEvent', 'visit-pro') if window.Intercom
